import { Station } from './../../models/Station';
import { Company } from './../../models/Company';
import { AnyAction } from 'redux';
import { ThunkDispatch } from 'redux-thunk';
import { firestore } from './../../firebase/firebase';

const GET_COMPANY_DETAILS = 'GET_COMPANY_DETAILS';
const GET_COMPANY_STATIONS = 'GET_COMPANY_STATIONS';

export interface GetCompanyDetails {
  type: typeof GET_COMPANY_DETAILS;
  payload: Company;
}

export interface GetCompanyStations {
  type: typeof GET_COMPANY_STATIONS;
  payload: Station[];
}

export type CompanyDetailsActions = GetCompanyDetails | GetCompanyStations;

const getCompanyDetailsAction = (company: Company): GetCompanyDetails => {
  return {
    type: 'GET_COMPANY_DETAILS',
    payload: company,
  };
};

const getStationsAction = (stations: Station[]): GetCompanyStations => {
  return {
    type: 'GET_COMPANY_STATIONS',
    payload: stations,
  };
};

export const getCompanyStations = (companyId: string) => {
  return async (dispatch: ThunkDispatch<{}, {}, AnyAction>) => {
    firestore
      .collection('stations')
      .where('companyId', '==', companyId)
      .onSnapshot((snapshot) => {
        const stations = snapshot.docs.map((doc) => {
          return new Station(
            doc.id,
            doc.data().stationName,
            doc.data().stationAddress,
            doc.data().stationPostcode,
            doc.data().stationState,
            doc.data().companyId,
            doc.data().companyName
          );
        });
        dispatch(getStationsAction(stations));
      });
  };
};

export const getCompanyDetails = (id: string) => {
  return async (dispatch: ThunkDispatch<{}, {}, AnyAction>) => {
    const snapshot = await firestore.collection('companies').doc(id).get();

    const company = new Company(
      snapshot.id,
      snapshot.data()?.applicantName,
      snapshot.data()?.icNumber,
      snapshot.data()?.contactNumber,
      snapshot.data()?.email,
      snapshot.data()?.position,
      snapshot.data()?.companyName,
      snapshot.data()?.ssmNumber,
      snapshot.data()?.address,
      snapshot.data()?.postcode,
      snapshot.data()?.state,
      snapshot.data()?.officeNumber,
      snapshot.data()?.officeEmail,
      snapshot.data()?.recommendedBy
    );

    //   const usersSnapshot = await firestore
    //     .collection('stations')
    //     .doc(id)
    //     .collection('users')
    //     .orderBy('timestamp', 'desc')
    //     .get();

    //   const users = usersSnapshot.docs.map(
    //     (doc) =>
    //       new User(
    //         doc.data().uid,
    //         doc.data().name,
    //         doc.data().icNumber,
    //         undefined,
    //         undefined,
    //         doc.data().timestamp.toDate()
    //       )
    //   );

    dispatch(getCompanyDetailsAction(company));
  };
};
